/*
  Growth Serum gift kits (30.10.2026): draws the kit notes in Rapid Cart.
  The notes are stored in the hidden line property _gs_note (JSON, written by snippets/gs-kit-note.liquid) so that
  checkout, the order and emails only show the short visible summary. Rapid Cart hides "_" properties, so this script
  reads cart.js and adds the lines under the kit title using Rapid Cart's own property markup; the styling (icons,
  free words, dashed value line) is the kit CSS in layout/theme.liquid. Rapid Cart redraws the drawer often, so a
  MutationObserver re-adds the notes whenever a kit line appears without them.
  Also rewrites the notes when the shopper switches language/market (3.11.2026, see relabel()).
  The cap on the discounted extra Growth Serum (30.10.2026) was removed on 4.11.2026 (Lan): plan buyers get the plan
  price on later orders anyway, so buying more at once is fine. capExtraSerum() is kept but does nothing.
*/
(function () {
  if (window.gsKitNotes) return;
  window.gsKitNotes = true;

  var KIT = /\/products\/(growth-serum-[a-z0-9-]*-kit)(?:[?#\/]|$)/;
  var SERUM = /\/products\/growth-serum(?:[?#\/]|$)/;
  var CAP = 3;
  var capSig = '';
  var capping = false;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cartCache = null;
  var cartAt = 0;
  var busy = false;
  var timer = null;

  function handleOf(url) {
    var m = KIT.exec(url || '');
    return m ? m[1] : null;
  }

  function getCart(force) {
    if (!force && cartCache && Date.now() - cartAt < 800) return Promise.resolve(cartCache);
    return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartCache = c; cartAt = Date.now(); return c; });
  }

  function line(label, value) {
    var row = document.createElement('div');
    row.className = 'rapi-cart-drawer__property gs-kp';
    var l = document.createElement('span');
    l.className = 'rapi-cart-drawer__property-label';
    l.textContent = label + ': ';
    var v = document.createElement('span');
    v.className = 'rapi-cart-drawer__property-value';
    v.textContent = value;
    row.appendChild(l);
    row.appendChild(v);
    return row;
  }

  function pending() {
    var out = [];
    document.querySelectorAll('.rapi-cart-drawer__name-block').forEach(function (block) {
      if (block.querySelector('.gs-kp-wrap') || block.getAttribute('data-gs-kp') === 'none') return;
      var a = block.querySelector('a[href*="/products/growth-serum-"][href*="-kit"]');
      var h = a && handleOf(a.getAttribute('href'));
      if (h) out.push({ block: block, handle: h });
    });
    return out;
  }


  function serumSignature() {
    var kit = false;
    var sig = [];
    document.querySelectorAll('.rapi-cart-drawer__name-block').forEach(function (block) {
      var a = block.querySelector('a[href*="/products/"]');
      var href = a ? a.getAttribute('href') : '';
      if (handleOf(href)) kit = true;
      else if (SERUM.test(href)) {
        var item = block.closest('[class*="item"]') || block.parentNode;
        var q = item && item.querySelector('input');
        sig.push(q ? q.value : (item ? item.textContent.length : '?'));
      }
    });
    return kit && sig.length ? sig.join(',') : '';
  }

  function capExtraSerum(cart) {
    return; /* cap removed 4.11.2026 (Lan) */
    if (capping) return;
    var hasKit = (cart.items || []).some(function (i) { return handleOf(i.url); });
    if (!hasKit) return;
    var over = (cart.items || []).filter(function (i) {
      return i.handle === 'growth-serum' && i.properties && i.properties._rapi_upsell && i.quantity > CAP;
    })[0];
    if (!over) return;
    capping = true;
    fetch(root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: over.key, quantity: CAP })
    }).then(function () {
      cartCache = null;
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }).catch(function () {}).then(function () { capping = false; capSig = ''; schedule(); });
  }

  /* 3.11.2026: notes follow the page language and market. A kit line whose _gs_sig (lang|currency at add time)
     differs from the current page gets its properties replaced with the current-language set rendered in
     layout/theme.liquid ([data-gs-kitnotes]). Same line, quantity and price; only the notes change. */
  var relabeling = false;
  var relabelChecked = false;
  function relabel(cart) {
    if (relabeling) return false;
    var box = document.querySelector('[data-gs-kitnotes-sig]');
    if (!box) return false;
    var sig = box.getAttribute('data-gs-kitnotes-sig');
    var item = (cart.items || []).filter(function (i) {
      var p = i.properties || {};
      return p._gs_plan && (p._gs_sig || '') !== sig && box.querySelector('[data-gs-kitnotes="' + p._gs_plan + '"]');
    })[0];
    if (!item) return false;
    var form = box.querySelector('[data-gs-kitnotes="' + item.properties._gs_plan + '"]');
    var props = {};
    Object.keys(item.properties).forEach(function (k) {
      if (k.charAt(0) === '_' && k.indexOf('_gs_') !== 0) props[k] = item.properties[k];
    });
    form.querySelectorAll('input[name^="properties["]').forEach(function (inp) {
      props[inp.name.slice(11, -1)] = inp.value;
    });
    relabeling = true;
    fetch(root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: props })
    }).then(function () {
      cartCache = null;
      document.querySelectorAll('.gs-kp-wrap').forEach(function (w) { w.remove(); });
      document.querySelectorAll('[data-gs-kp]').forEach(function (b) { b.removeAttribute('data-gs-kp'); });
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }).catch(function () {}).then(function () { relabeling = false; schedule(); });
    return true;
  }

  function run() {
    if (busy) return;
    var todo = pending();
    var sig = serumSignature();
    var needCap = sig && sig !== capSig;
    var needRelabel = !relabelChecked && document.querySelector('[data-gs-kitnotes-sig]');
    if (!todo.length && !needCap && !needRelabel) return;
    relabelChecked = true;
    capSig = sig;
    busy = true;
    getCart(true).then(function (cart) {
      if (relabel(cart)) return false;
      capExtraSerum(cart);
      todo.forEach(function (t) {
        if (!document.contains(t.block) || t.block.querySelector('.gs-kp-wrap')) return;
        var item = (cart.items || []).filter(function (i) { return handleOf(i.url) === t.handle && i.properties && i.properties._gs_note; })[0];
        var note = null;
        if (item) { try { note = JSON.parse(item.properties._gs_note); } catch (e) { note = null; } }
        if (!note) { t.block.setAttribute('data-gs-kp', 'none'); return; }
        var wrap = document.createElement('div');
        wrap.className = 'gs-kp-wrap';
        if (note.inc) wrap.appendChild(line(note.inc[0], note.inc[1]));
        (note.lines || []).forEach(function (pair) { wrap.appendChild(line(pair[0], pair[1])); });
        var native = t.block.querySelector('.rapi-cart-drawer__property:not(.gs-kp)');
        if (native && native.parentNode) native.parentNode.insertBefore(wrap, native.nextSibling);
        else {
          var a = t.block.querySelector('a[href*="-kit"]');
          var anchor = a && a.parentNode && a.parentNode !== t.block ? a.parentNode : a;
          if (anchor && anchor.parentNode === t.block) t.block.insertBefore(wrap, anchor.nextSibling);
          else t.block.appendChild(wrap);
        }
      });
      return true;
    }).catch(function () { return false; }).then(function (ok) { busy = false; if (ok && pending().length) schedule(); });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 120);
  }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', schedule);
  schedule();
})();
